import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store";
import { ContractManagementDashboardFilterModel } from "models/Dashboard/DashboardTilesFilterModel";
import { setSelectedContractDashboardFilter } from "redux/masterPageStateSlice";

export type ContractDashboardFilterStateModel = {
	assignedToIds: string[];
	erpDbCompanyIds: string[];
	divisionIds: string[];
	regionIds: string[];
	departmentErpDbCompanyIds: string[];
	programmeIds: string[];
	procurementMethodIds: string[];
	contractManagerIds: string[];
	supplierIds: string[];
	enterpriseTypeIds: string[];
	beeLevelIds: string[];
	expiresInIds: string[];
	contractStatusIds: string[];
};

export const contractDashboardFilterStateInitialValue = {
	assignedToIds: [],
	erpDbCompanyIds: [],
	divisionIds: [],
	regionIds: [],
	departmentErpDbCompanyIds: [],
	programmeIds: [],
	procurementMethodIds: [],
	contractManagerIds: [],
	supplierIds: [],
	enterpriseTypeIds: [],
	beeLevelIds: [],
	expiresInIds: [],
	contractStatusIds: [],
};

const useContractDashboardFilter = () => {
	const dispatch = useDispatch();
	const selectedContractDashboardFilters: ContractDashboardFilterStateModel =
		useSelector(
			(state: RootState) => state.masterPageState.contractDashboardFilterDetail
		);

	const setSelectedContractFilter = (
		filterModel: ContractManagementDashboardFilterModel
	) => {
		dispatch(
			setSelectedContractDashboardFilter({
				assignedToIds: filterModel.assignedToIds,
				erpDbCompanyIds: filterModel.erpDbCompanyIds,
				divisionIds: filterModel.divisionIds,
				regionIds: filterModel.regionIds,
				departmentErpDbCompanyIds: filterModel.departmentErpDbCompanyIds,
				programmeIds: filterModel.programmeIds,
				procurementMethodIds: filterModel.procurementMethodIds,
				contractManagerIds: filterModel.contractManagerIds,
				supplierIds: filterModel.supplierIds,
				enterpriseTypeIds: filterModel.enterpriseTypeIds,
				beeLevelIds: filterModel.beeLevelIds,
				expiresInIds: filterModel.expiresInIds,
				contractStatusIds: filterModel.contractStatusIds,
			})
		);
	};

	const resetSelectedFilter = () => {
		dispatch(
			setSelectedContractDashboardFilter(
				contractDashboardFilterStateInitialValue
			)
		);
	};

	const hasSelectedFilter = () => {
		return (
			selectedContractDashboardFilters &&
			Object.values(selectedContractDashboardFilters).some((s) => s.length > 0)
		);
	};

	const assignedToIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.assignedToIds.length > 0
			? selectedContractDashboardFilters.assignedToIds
			: [];

	const erpDbCompanyIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.erpDbCompanyIds.length > 0
			? selectedContractDashboardFilters.erpDbCompanyIds
			: [];

	const divisionIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.divisionIds.length > 0
			? selectedContractDashboardFilters.divisionIds
			: [];

	const regionIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.regionIds.length > 0
			? selectedContractDashboardFilters.regionIds
			: [];

	const departmentErpDbCompanyIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.departmentErpDbCompanyIds.length > 0
			? selectedContractDashboardFilters.departmentErpDbCompanyIds
			: [];

	const programmeIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.programmeIds.length > 0
			? selectedContractDashboardFilters.programmeIds
			: [];

	const procurementMethodIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.procurementMethodIds.length > 0
			? selectedContractDashboardFilters.procurementMethodIds
			: [];

	const contractManagerIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.contractManagerIds.length > 0
			? selectedContractDashboardFilters.contractManagerIds
			: [];

	const supplierIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.supplierIds.length > 0
			? selectedContractDashboardFilters.supplierIds
			: [];

	const enterpriseTypeIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.enterpriseTypeIds.length > 0
			? selectedContractDashboardFilters.enterpriseTypeIds
			: [];

	const beeLevelIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.beeLevelIds.length > 0
			? selectedContractDashboardFilters.beeLevelIds
			: [];

	const expiresInIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.expiresInIds.length > 0
			? selectedContractDashboardFilters.expiresInIds
			: [];

	const statusIds =
		selectedContractDashboardFilters &&
		selectedContractDashboardFilters.contractStatusIds.length > 0
			? selectedContractDashboardFilters.contractStatusIds
			: [];

	return {
		resetSelectedFilter,
		hasSelectedFilter,
		setSelectedContractFilter,
		assignedToIds,
		erpDbCompanyIds,
		divisionIds,
		regionIds,
		departmentErpDbCompanyIds,
		programmeIds,
		procurementMethodIds,
		contractManagerIds,
		supplierIds,
		enterpriseTypeIds,
		beeLevelIds,
		expiresInIds,
		statusIds,
	};
};

export default useContractDashboardFilter;
